import React, { type FC } from 'react';
import { ListSortProps } from '../../utility/types';
import SelectListSortDropdown from './SelectListSortDropdown';

interface DecisionMakingHeaderProps {
  title: string;
  activeListSort: ListSortProps;
  listSorts: ListSortProps[];
  navigateToSelectedListSort: (listSort: ListSortProps) => void;
}

const DecisionMakingHeader: FC<DecisionMakingHeaderProps> = ({ title, activeListSort, listSorts, navigateToSelectedListSort }) => {
  return (
    <div id='DecisionMakingHeader-container' className='flex whitespace-nowrap flex-col px-3 border-5 border-indigo-200'>
      <div id='DecisionMakingHeader-list-sort-container' className='flex whitespace-nowrap items-center p-3'>
        <div id='DecisionMakingHeader-list-sort-container' className='w-full h-fit ml-5 flex items-center'>
          <SelectListSortDropdown
            listSorts={listSorts}
            onListSortSelect={(listSort) => {
              navigateToSelectedListSort(listSort);
            }}
            activeListSort={activeListSort}
          />
          {/* The Custom List ID lookup is rendered here by LitePropertyList, which owns the list position state */}
          <div id='portal-container-custom-list-id-lookup' className='ml-10'></div>
        </div>
      </div>
      <div className='w-full h-fit'>
        <hr />
      </div>
    </div>
  );
};

export default DecisionMakingHeader;
